import { render, staticRenderFns } from "./footer-sns.vue?vue&type=template&id=693ceb2e"
import script from "./footer-sns.vue?vue&type=script&lang=js"
export * from "./footer-sns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports